var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      attrs: {
        "label-width": _vm.$attrs["label-width"],
        prop: _vm.$attrs["prop"],
        label: _vm.$attrs["label"],
      },
    },
    [
      _c(
        "el-radio-group",
        {
          attrs: { disabled: _vm.disabled },
          on: { change: _vm.handleRadioChange },
          model: {
            value: _vm.labelResult,
            callback: function ($$v) {
              _vm.labelResult = $$v
            },
            expression: "labelResult",
          },
        },
        _vm._l(_vm.labelList, function (item, index) {
          return _c("el-radio", {
            key: index,
            class: _vm.labelClass,
            attrs: { label: item },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }